type ReadmeBranch = {
  readonly name: string;
  readonly headCommit:
    | { readonly readmeDescription?: string | null }
    | null
    | undefined;
};

export function workflowReadmeSnippet(
  branches: readonly ReadmeBranch[] | undefined
): string | null {
  const main = branches?.find((b) => b.name === "main") ?? branches?.[0];
  return main?.headCommit?.readmeDescription ?? null;
}
